import React from "react";

import ProductVariant from "@configuratorware/configurator-frontendgui/App/Shared/Containers/ProductVariant";
import CustomProductVariant from "../../Components/CustomProductVariant";

const CustomProductVariantContainer = (props) => {

  return (
      <>
        <ProductVariant
            ProductVariantComponent={CustomProductVariant}
            {...props}
        >
        </ProductVariant>
      </>

  );
};

export default CustomProductVariantContainer;
